export default "__VITE_ASSET__7ec4428f__"